import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { getRangeFromSearch, setRangeInSearch } from './utils'

// The selected window lives in the query string, so a refresh or a shared link
// opens the same range. `select` takes `{ preset }` or `{ start, end }`.
const useAnalyticsRange = () => {
  const { search } = useLocation()
  const history = useHistory()
  const range = useMemo(() => getRangeFromSearch(search), [search])
  const select = useCallback(
    selection =>
      history.replace({ search: setRangeInSearch(search, selection) }),
    [history, search],
  )

  return [range, select]
}

export default useAnalyticsRange
